import { render } from "./AppLoader.vue?vue&type=template&id=24856316&scoped=true"
const script = {}

import "./AppLoader.vue?vue&type=style&index=0&id=24856316&scoped=true&lang=css"

import exportComponent from "/home/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24856316"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
